import {combineReducers} from 'redux-immutable';
import workOrder from './work-order/workOrderReducer';
import techData from './techDataReducer';
import message from './messageReducer';
import error from './errorReducer';
import transactionLog from './transactionLogReducer';
import user from './userReducer';
import site from './siteReducer';
import {immutableReducer as oidc} from 'redux-oidc';
import {reducer as toastrReducer} from 'react-redux-toastr';

const rootReducer = combineReducers({
    workOrder,
    techData,
    message,
    error,
    oidc,
    transactionLog,
    user,
    site,
    toastr: toastrReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js